import { yup } from '@framework/validation/initYup.ts';

/**
 * Schema Yup per le opzioni WFS di un layer.
 *
 * `typeName` è l'unico campo scelto dall'operatore; `version`,
 * `outputFormat` e `nativeCrs` vengono rilevati a config-time
 * dall'introspezione del servizio (GetCapabilities) e persistiti
 * perché a runtime non servano chiamate aggiuntive.
 */
export const MapLayerWfsSchema = yup.object({
  /**
   * Feature type qualificato esposto dal servizio
   * (es. 'osm:water_areas').
   */
  typeName: yup.string().required().label('Feature Type (typeName)'),
  /**
   * Versione WFS negoziata con il servizio.
   */
  version: yup
    .string()
    .oneOf(['1.1.0', '2.0.0'])
    .default('2.0.0')
    .label('Versione WFS'),
  /**
   * outputFormat per GetFeature dichiarato dal servizio.
   * Assente → risposta GML.
   */
  outputFormat: yup
    .string()
    .nullable()
    .notRequired()
    .label('Formato di output'),
  /**
   * CRS nativo dichiarato dal servizio per il feature type.
   */
  nativeCrs: yup.string().notRequired().label('CRS nativo'),
});
